var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSteeringWheel = function SvgSteeringWheel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0m0 4c5.207 0 9.606 3.353 11.266 8H4.734C6.394 7.353 10.794 4 16 4m0 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4M4 16c5.465 0 9.89 5.266 9.984 11.797C8.328 26.828 4 21.926 4 16m14.016 11.797C18.11 21.266 22.536 16 28 16c0 5.926-4.328 10.828-9.984 11.797"
  })));
};
export default SvgSteeringWheel;